import gql from "graphql-tag";

export const LOGIN_MUTATION = gql`
  mutation login($user_name: String!, $password: String!) {
    login(user_name: $user_name, password: $password) {
      ok
      message
      token
      status
      error {
        path
        message
      }
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation logout($type: String!) {
    logout(type: $type) {
      ok
      message
      status
    }
  }
`;

export const GET_USER = gql`
  {
    me {
      __typename
      ... on T_response {
        ok
        status
        message
        error {
          path
          message
        }
      }

      ... on me {
        ok
        status
        message
        data {
          user_id
          first_name
          last_name
          email
          phone_number
          user_name
          role {
            role_id
            role
          }
          refferal_code
          active
          subscribed

          picture_url
          profile_pic {
            blob
            encoding
            filename
            id
            mimetype
          }
          identification {
            blob
            encoding
            filename
            id
            mimetype
          }
          newdesignjt
          confirmed
          forgotPasswordLock

          student_type
          law_school {
            name
            location
            accreditation
          }
          law_universitiy {
            name
            location
            accreditation
          }
          uL_student_number

          region
          current_region

          active_subscription {
            id
            start
            end
            subscription_reference
            subscription_plan {
              subscription_plan_id
              name
              active
              amount
              description
              domain
              feature_list
              plan_code
              interval
              provider
              sub_plan_class {
                name
                description
              }
            }
          }

          subscription_plan_invoice {
            subscription_plan_invoice_id
            subscription_reference

            completed
            provider_response

            date
            region
            currency
            start
            end
            subscription_plan {
              subscription_plan_id
              active
              amount
              name
              description
              domain
              feature_list
              plan_code
              interval
              provider
            }
          }
        }
      }
    }
  }
`;
